<template>
  <background-particles />
  <v-container
    fluid
    class="fill-height bg-primary"
  >
    <v-row class="d-flex align-center justify-center">
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          v-motion-roll-right
          class="pa-6 pa-md-12 bg-white text-center"
          elevation="24"
        >
          <div>
            <div>
              <Vue3Lottie
                :animationData="DoneJSON"
                :width="200"
              />
            </div>
            <div class="mb-6 text-primary text-h5">Payment Successful!</div>
            <div>
              <v-btn
                @click="$router.replace('/')"
                color="primary"
                rounded="lg"
                variant="flat"
              >
                Continue
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
  import BackgroundParticles from "@/components/BackgroundParticles.vue";
  import DoneJSON from "@/assets/done.json";
</script>
